import { lazy, Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import ErrorBoundary from './components/ErrorBoundary';
import LoadingSpinner from './components/LoadingSpinner';
import PageNotFound from './pages/PageNotFound'; 

const Home = lazy(() => import('./pages/Home'));
const Shop = lazy(() => import('./pages/Shop'));
const About = lazy(() => import('./pages/About'));
const Contact = lazy(() => import('./pages/Contact'));
const Customers = lazy(() => import('./pages/Customers'));
const Products = lazy(() => import('./pages/SweetTreatsPage'));
const Menu = lazy(() => import('./pages/FullMenu'));
const Traditional = lazy(() => import('./components/products/Traditional'));
const Sandesh = lazy(() => import('./components/products/Sandesh-varieties'));
const Pitha = lazy(() => import('./components/products/Pitha'));
const LaddooBarfi = lazy(() => import('./components/products/LaddooBarfi'));
const Millet = lazy(() => import('./components/products/Millet'));
const Snacks = lazy(() => import('./components/products/Snacks'));
const GrandOpening = lazy(() => import('./pages/GrandOpening'));

function App() {
  return (
    <Router>
      <Header />
      <ErrorBoundary>
        <Suspense fallback={<LoadingSpinner />}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/shop" element={<Shop />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/customers" element={<Customers />} />
            <Route path="/products" element={<Products />} />
            <Route path="/full-menu" element={<Menu />} />
            <Route path="/grand-opening" element={<GrandOpening />} />

            <Route path="/shop/traditional" element={<Traditional />} />
            <Route path="/shop/sandesh-varieties" element={<Sandesh />} />
            <Route path="/shop/pitha" element={<Pitha />} />
            <Route path="/shop/laddoo-barfi" element={<LaddooBarfi />} />
            <Route path="/shop/millet" element={<Millet />} />
            <Route path="/shop/snacks" element={<Snacks />} />
            
            {/* Add this catch-all route at the end */}
            <Route path="*" element={<PageNotFound />} />
          </Routes>
        </Suspense>
      </ErrorBoundary>
      <Footer />
    </Router>
  );
}

export default App;